export const ERR_INVALID_USER_ID = 'Invalid User ID';
export const ERR_INVALID_CODE = 'Invalid Code';
export const ERR_INVALID_USER_AND_CODE = 'Invalid User ID and Code';
export const ERR_INVALID_ACCOUNT_NUMBER = 'Invalid Account Number';
export const ERR_INVALID_OTP_NUMBER = 'Invalid OTP Number';
export const ERR_INVALID_ACCOUNT_AND_OTP = 'Invalid Account or OTP Number';
export const ERR_INVALID_TAC = 'Invalid TAC';
export const ERR_MAXIMUM_TAC = 'Maximum TAC error limit reached.';
export const ERR_SAME_OLD_PASSWORD = 'LDAP error code 19:Failed to update password';
export const MESSAGE_SUCCESS = 'Success';
export const RESPONSE_CODE_SUCCESS_TAC = '0';
